const locale = {
	// #region Fields
	DIALOG_COMMON_ID: 'ID',
	DIALOG_COMMON_TITLE: 'Name',
	DIALOG_COMMON_DESCRIPTION: 'Description',
	DIALOG_COMMON_ORDER: 'Sorting Order',
	DIALOG_COMMON_TITLE_INITIALS: 'Initials',
	DIALOG_COMMON_DISABLED: 'Disabled',
	DIALOG_COMMON_RECOVERY_HOURS: 'Recovery hours',
	DIALOG_LEAVE_TYPES_ADMIN_ONLY: 'Admin only',
	DIALOG_LEAVE_TYPES_RECOVERY_HOURS: 'Recovery hours',
	DIALOG_LEAVE_TYPES_MIN_NOTICE_DAYS: 'Minimum notice (days)',
	DIALOG_LEAVE_TYPES_CALENDAR_SHOW: 'Show in availability calendar',
	DIALOG_LEAVE_TYPES_SHOW_TITLE: 'Show information in availability calendar',
	DIALOG_LEAVE_TYPES_SHOW_WEEKEND: 'Selectable outside of working hours',
	DIALOG_LEAVE_TYPES_SHOW_REPORT: 'Show in availability report'
	// #endregion
};

export default locale;
